export default class CustomError extends Error {
	data;

	constructor(message, data) {
		super(message);
		this.data = data;
	}
}